<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  boards: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['select']);

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col items-center justify-center gap-4 py-16 px-6 text-center"
  >
    <div
      class="flex h-14 w-14 items-center justify-center rounded-2xl bg-n-slate-3"
    >
      <i class="i-lucide-filter w-7 h-7 text-n-slate-11" />
    </div>
    <div class="flex flex-col gap-1 max-w-md">
      <h3 class="text-base font-medium text-n-slate-12">
        {{ t('KANBAN.REPORTS.BOARD_REQUIRED.TITLE') }}
      </h3>
      <p class="text-sm text-n-slate-11">
        {{ t('KANBAN.REPORTS.BOARD_REQUIRED.DESCRIPTION') }}
      </p>
    </div>
    <div
      v-if="boards.length"
      class="flex flex-wrap items-center justify-center gap-2 max-w-xl"
    >
      <button
        v-for="board in boards"
        :key="board.id"
        type="button"
        class="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-n-slate-4 bg-n-alpha-1 text-sm text-n-slate-12 hover:bg-n-alpha-2 hover:border-n-slate-6 transition-colors"
        @click="emit('select', board.id)"
      >
        <i class="i-lucide-kanban w-4 h-4 text-n-slate-10" />
        <span class="truncate max-w-[200px]">{{ board.name }}</span>
      </button>
    </div>
  </div>
</template>
